import './index.scss';

(function ($) {
  'use strict';

  function isValidToRender(el, data) {
    return el.length > 0 && Object.values(data).length > 0;
  }

  function incomePercentageChart(ctx) {
    const data = ctx.data();

    if (!isValidToRender(ctx, data)) {
      return false;
    }

    return new window.Chart(ctx, {
      type: 'pie',
      data: {
        counts: [data.hitsCount, data.mistakesCount],
        mistakesCount: data.mistakesCount,
        datasets: [{
          label: '%',
          data: [data.hits, data.mistakes],
          backgroundColor: [
            data.hitsColor,
            data.mistakesColor
          ]
        }],
        labels: ['Acertos', 'Erros']
      },
      options: {
        tooltips: {
          callbacks: {
            label: (tooltipItem, chartData) => {
              const i = tooltipItem.index;
              return `${chartData.labels[i]}: ${chartData.counts[i]} | ${chartData.datasets[0].data[i]}%`;
            }
          }
        },
        cutoutPercentage: 50,
        title: {
          display: true,
          text: 'Percentual de Rendimento'
        }
      }
    });
  }

  function mostAnsweredAlternativesChart(ctx) {
    const data = ctx.data();

    if (!isValidToRender(ctx, data)) {
      return false;
    }

    new window.Chart(ctx, {
      type: 'bar',
      data: {
        counts: data.alternativesCount.split(', '),
        labels: data.options.split(','),
        datasets: [{
          label: '%',
          data: data.pecentages.split(',').map(x => parseFloat(x)),
          backgroundColor: data.colours.split(','),
          borderWidth: 0
        }]
      },
      options: {
        legend: {
          display: false
        },
        title: {
          display: true,
          text: 'Alternativas mais respondidas'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, chartData) => {
              const i = tooltipItem.index;
              return `${chartData.counts[i]} | ${tooltipItem.yLabel}%`;
            }
          }
        }
      }
    });
  }

  $(document)
    .off('componentLoaded:questions/question_statistics')
    .on('componentLoaded:questions/question_statistics', (e, data) => {
      vendorManager.ensure('chart.js', () => {
        const $incomePercentageChart = $('#js-income-percentage-chart', data.context);
        const $mostAnsweredAlternativesChart = $('#js-most-answered-alternatives-chart', data.context);

        incomePercentageChart($incomePercentageChart);
        mostAnsweredAlternativesChart($mostAnsweredAlternativesChart);
      });
    });
})(jQuery);
